class NewsletterFormValidation extends HTMLElement {
  connectedCallback() {
    this._onSubmit = this._onSubmit.bind(this);
    document.addEventListener('submit', this._onSubmit, true);
  }

  disconnectedCallback() {
    document.removeEventListener('submit', this._onSubmit, true);
  }

  _onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('form--newsletter')) {
      return;
    }

    const consent = form.querySelector('input[name="contact[privacy_consent]"][type="checkbox"]');
    if (!consent || !consent.required) {
      return;
    }

    if (consent.checked) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    consent.focus({ preventScroll: false });
    if (typeof consent.reportValidity === 'function') {
      consent.reportValidity();
    }
  }
}

if (!window.customElements.get('newsletter-form-validation')) {
  window.customElements.define('newsletter-form-validation', NewsletterFormValidation);
}
